export default __webpack_public_path__ + "static/banner-the-reality-of-work-and-travel-cape-town-cfbd3f1fda877f2e2b38a2966292341c.jpg";